// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3u_61","footer":"ModalError_footer__3N89w"};